export const mentionCandidates = [{ id: 0, display: "PREP" }];

export const updateMentionCandidates = (profiles) => {
    const nextCandidates = Array.isArray(profiles)
        ? profiles.map((profile) => ({
              id: profile.id,
              display: profile.name,
          }))
        : [];

    mentionCandidates.splice(1, mentionCandidates.length - 1, ...nextCandidates);
};

// @[display](id) 형태의 멘션 파싱 정규식
const mentionRegex = /@\[[^\]]+\]\((\d+)\)/g;
const mentionReplaceRegex = /@\[([^\]]+)\]\(([^)]+)\)/g;

export const matchMention = (content) => {
    return mentionRegex.exec(content);
};

export const hasMention = (content) => {
    return mentionRegex.exec(content) !== null;
};

export const hasPrepMention = (content) => {
    return content && content.indexOf("@[PREP](0)") > -1;
};

export const mentionToDisplayText = (content, { prefix = true } = {}) => {
    if (!content) return "";
    return content.replace(mentionReplaceRegex, `${prefix ? "@" : ""}$1`);
};

const escapeHtml = (content) =>
    String(content || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

export const mentionToHtml = (content) =>
    escapeHtml(content).replace(
        mentionReplaceRegex,
        `<span style="color: green; font-size: 1.4rem; display: inline-block;">@$1</span>`,
    );
